import PropTypes from 'prop-types';
import React from 'react';

import { Card } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import SearchUser from './views/SearchUser';

const UserAdminSearchUser = ({ handleSetUsername }) => {
  return (
    <Feature allowed={'agencySecurityUserAdministration'}>
      <Card>
        <SearchUser handleSetUsername={handleSetUsername} />
      </Card>
    </Feature>
  );
};

UserAdminSearchUser.propTypes = {
  handleSetUsername: PropTypes.func,
  hideReturn: PropTypes.bool,
};

export default UserAdminSearchUser;
